// extracted by mini-css-extract-plugin
export var closeButton = "_bx-1";
export var closeX = "_bx-3";
export var container = "_bx-0";
export var image = "_bx-2";